/* New Release article — behaviour */
(function () {
  document.querySelectorAll('.nr-article:not([data-nr-ready])').forEach(function (root) {
    root.setAttribute('data-nr-ready', '');

    /* Buy-box gallery: 1 image per view */
    var slider = root.querySelector('.nr-slider');
    if (slider) {
      var track = slider.querySelector('.nr-slider__track');
      var slides = track.children.length, i = 0, timer;
      var prev = slider.querySelector('.nr-arrow--prev'), next = slider.querySelector('.nr-arrow--next');
      var go = function (n) { if (!slides) return; i = (n + slides) % slides; track.style.transform = 'translateX(' + (-100 * i) + '%)'; };
      var auto = function () { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, parseInt(slider.dataset.autoplay, 10) || 5000); };
      prev.addEventListener('click', function () { go(i - 1); auto(); });
      next.addEventListener('click', function () { go(i + 1); auto(); });
      var x0 = null;
      track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); auto(); } x0 = null; });
      if (slides < 2) { prev.style.display = next.style.display = 'none'; } else { auto(); }
    }

    /* Content sliders: scroll-snap carousels */
    root.querySelectorAll('[data-nr-car]').forEach(function (car) {
      var t = car.querySelector('.nr-car__track');
      var bar = car.querySelector('.nr-car__bar span');
      var p = car.querySelector('.nr-arrow--prev'), n = car.querySelector('.nr-arrow--next');
      var step = function () { var it = t.children[0]; return it ? it.getBoundingClientRect().width + (parseFloat(getComputedStyle(t).columnGap) || 12) : t.clientWidth; };
      var upd = function () {
        var max = t.scrollWidth - t.clientWidth;
        car.classList.toggle('is-static', max <= 2);
        var ratio = t.clientWidth / t.scrollWidth;
        bar.style.width = (ratio * 100) + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (t.scrollLeft / max) * ((1 / ratio) - 1) * 100 : 0) + '%)';
        p.disabled = t.scrollLeft <= 2; n.disabled = t.scrollLeft >= max - 2;
      };
      p.addEventListener('click', function () { t.scrollBy({ left: -step(), behavior: 'smooth' }); });
      n.addEventListener('click', function () { t.scrollBy({ left: step(), behavior: 'smooth' }); });
      t.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      Array.prototype.forEach.call(t.querySelectorAll('img'), function (im) { if (!im.complete) im.addEventListener('load', upd); });
      upd();
    });

    /* Content images jump to the buy box */
    var buy = root.querySelector('#product-action');
    if (buy) {
      root.querySelectorAll('.nr-hero__img img, .nr-pair img, .nr-car img').forEach(function (img) {
        img.style.cursor = 'pointer';
        img.addEventListener('click', function () { buy.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
      });
    }

    /* Variant picker */
    var vEl = root.querySelector('[data-nr-variants]');
    if (!vEl) return;
    var variants = JSON.parse(vEl.textContent);
    var idInput = root.querySelector('[data-nr-variant]');
    var addBtn = root.querySelector('.nr-add');
    var buyBtn = root.querySelector('[data-nr-buynow]');
    var addLabel = root.querySelector('[data-nr-add-label]');
    var priceEl = root.querySelector('[data-nr-price]');
    var cmpEl = root.querySelector('[data-nr-compare]');
    var sets = root.querySelectorAll('.nr-opt');
    var money = function (c) { return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(c) : '$' + (c / 100).toFixed(2); };
    var selected = function () { return Array.prototype.map.call(sets, function (s) { var a = s.querySelector('.is-active'); return a ? a.dataset.value : null; }); };
    var find = function (sel) { return variants.find(function (v) { return v.options.every(function (o, k) { return o === sel[k]; }); }); };
    var update = function () {
      var sel = selected(), v = find(sel);
      if (sets.length) {
        var lastIdx = sets.length - 1;
        sets[lastIdx].querySelectorAll('.nr-opt__btn').forEach(function (b) {
          var test = sel.slice(); test[lastIdx] = b.dataset.value;
          var m = find(test);
          b.classList.toggle('is-unavailable', !m || !m.available);
        });
      }
      if (!v) { addBtn.disabled = buyBtn.disabled = true; addLabel.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      priceEl.textContent = money(v.price);
      if (cmpEl) { cmpEl.hidden = !(v.compare_at_price > v.price); cmpEl.textContent = money(v.compare_at_price || 0); }
      addBtn.disabled = buyBtn.disabled = !v.available;
      addLabel.textContent = v.available ? root.dataset.tAdd : root.dataset.tSold;
    };
    sets.forEach(function (s) {
      s.addEventListener('click', function (e) {
        var b = e.target.closest('.nr-opt__btn'); if (!b) return;
        s.querySelectorAll('.nr-opt__btn').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        var lbl = s.querySelector('[data-nr-opt-label]'); if (lbl) lbl.textContent = b.dataset.value;
        update();
      });
    });

    /* Quantity buttons */
    root.querySelectorAll('.nr-qty .quantity__button').forEach(function (b) {
      b.addEventListener('click', function () {
        var q = root.querySelector('.nr-qty input');
        q.value = Math.max(1, (parseInt(q.value, 10) || 1) + (b.name === 'plus' ? 1 : -1));
      });
    });

    /* Buy Now: add to cart, then go straight to checkout */
    buyBtn.addEventListener('click', function () {
      var qty = parseInt((root.querySelector('.nr-qty input') || {}).value, 10) || 1;
      buyBtn.classList.add('loading');
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: qty }] })
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status) { buyBtn.classList.remove('loading'); window.alert(res.description || res.message); return; }
        window.location.href = '/checkout';
      }).catch(function () { buyBtn.classList.remove('loading'); });
    });
    update();
  });
})();
